import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../../handlers/http-responses-handler';
import { BaseDataService } from '../base.data.service';
import { Injectable } from '@angular/core';
import { SupplierMetricsDTO } from '../../interfaces/gamification/supplier-metrics.dto';

@Injectable({
  providedIn: 'root',
})
export class SupplierMetricsService extends BaseDataService {
  url = '/api/supplier-metrics';
  entityTitle = 'Supplier Metrics';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getWeeklyMetrics(): Promise<SupplierMetricsDTO> {
    return this.handleRequest<SupplierMetricsDTO>(
      this.http.get<SupplierMetricsDTO>(`${this.url}/this-week`),
      this.handlersFactory.getForReadAll(),
    );
  }

  getMonthlyMetrics(): Promise<SupplierMetricsDTO> {
    return this.handleRequest<SupplierMetricsDTO>(
      this.http.get<SupplierMetricsDTO>(`${this.url}/this-month`),
      this.handlersFactory.getForReadAll(),
    );
  }

  getCustomRangeMetrics(rangeStart: string, rangeEnd: string): Promise<SupplierMetricsDTO> {
    return this.handleRequest<SupplierMetricsDTO>(
      this.http.get<SupplierMetricsDTO>(
        `${this.url}/range?fromDate=${rangeStart}&toDate=${rangeEnd}`,
      ),
      this.handlersFactory.getForReadAll(),
    );
  }
}
